import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxMaskModule } from 'ngx-mask';

import {
  AutoSelectComponent,
  ButtonComplexComponent,
  ControlErrorsComponent,
  ControlWrapperComponent,
  DatePickerComponent,
  DateRangePickerComponent,
  DropdownActionComponent,
  RadioButtonCardComponent,
  RadioButtonComponent,
  RadioButtonTagComponent,
  SearchInputComponent,
  SearchPanelComponent,
  SearchWrapperComponent,
  StatusSelectComponent,
  SwitchButtonComponent,
  TextEditorComponent,
  TimePickerDropdownComponent,
} from './components';
import { IconsModule } from '@shared/icons/icons.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { NgSelectModule } from '@ng-select/ng-select';
import { DirectivesModule } from '@shared/directives/directives.module';

import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { QuillModule } from 'ngx-quill';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { CustomTooltipModule } from '@shared/tooltip/custom-tooltip.module';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgxMaskModule,
    IconsModule,
    BsDatepickerModule,
    NgxMaterialTimepickerModule,
    NgSelectModule,
    NzToolTipModule,
    DirectivesModule,
    NzTimePickerModule,
    QuillModule.forRoot(),
    BsDropdownModule,
    NzSwitchModule,
    CustomTooltipModule,
  ],
  declarations: [
    RadioButtonComponent,
    ControlErrorsComponent,
    ControlWrapperComponent,
    SearchWrapperComponent,
    SearchPanelComponent,
    SearchInputComponent,
    DatePickerComponent,
    DateRangePickerComponent,
    TimePickerDropdownComponent,
    TextEditorComponent,
    AutoSelectComponent,
    StatusSelectComponent,
    ButtonComplexComponent,
    DropdownActionComponent,
    SwitchButtonComponent,
    RadioButtonCardComponent,
    RadioButtonTagComponent,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    RadioButtonComponent,
    ControlWrapperComponent,
    ControlErrorsComponent,
    SearchWrapperComponent,
    SearchPanelComponent,
    SearchInputComponent,
    DatePickerComponent,
    DateRangePickerComponent,
    TimePickerDropdownComponent,
    TextEditorComponent,
    AutoSelectComponent,
    StatusSelectComponent,
    ButtonComplexComponent,
    DropdownActionComponent,
    SwitchButtonComponent,
    RadioButtonCardComponent,
    RadioButtonTagComponent,
  ],
})
export class FormWrapperModule {}
